module.exports = __webpack_public_path__ + "static/media/login-closed-eye.3523ce5f.svg";